module.exports = __webpack_public_path__ + "img/thumb-hg.67dae283.jpg";